<template>
  <div class="calendar-adday-task">
    <div
      v-if="tasks.length > 0"
      class="calendar-adday-task-left"
    >
      <span class="calendar-adday-task-title">全天</span>
      <div
        v-show="tasks.length > 3"
        class="calendar-adday-task-toggle"
        @click="showAll"
      >
        <span
          v-if="filterNum > 3"
          class="ibass ibass-arrow-up"
        />
        <span
          v-else
          class="ibass ibass-arrow-down"
        />
      </div>
    </div>
    <div
      class="calendar-adday-task-items"
      :class="{
        'transition': filterNum > 2
      }"
      :style="{
        'height': maxHeight
      }"
    >
      <div
        v-for="(item, index) in filteredTasks"
        :key="index"
        class="calendar-adday-task-item"
        :class="{
          'done': item.state === 1
        }"
      >
        <el-popover
          v-model="item.triggered"
          placement="bottom"
          trigger="hover"
        >
          <div
            slot="reference"
            class="calendar-adday-task-trigger"
            :class="{
              'triggered': item.triggered
            }"
          >
            <em
              v-if="item.state === 1"
              class="ibass ibass-done"
            />
            <span class="calendar-adweek-task-label">{{ item.name }}</span>
          </div>
          <task-info
            :task="item"
            @close="item.triggered = false"
          />
        </el-popover>
      </div>
      <div
        v-show="showMore"
        @click="showAll"
        class="calendar-adday-task-more"
      >
        <span class="calendar-adday-more-label">{{ `更多 ${tasks.length-filterNum} 个` }}</span>
        <span class="ibass ibass-trig-down" />
      </div>
    </div>
  </div>
</template>
<script>
import TaskInfo from '../tasks/taskInfo'
import _ from 'lodash'
const DEFAULT_SHOW_NUMBER = 2
export default {
  name: 'CalendarAllDayDayTask',
  components: {
    TaskInfo
  },
  props: {
    tasks: {
      type: Array
    },
    curDate: {
      type: String
    }
  },
  data () {
    return {
      filterNum: DEFAULT_SHOW_NUMBER
    }
  },
  computed: {
    filteredTasks () {
      let _tasks = _.orderBy(this.tasks, ['state'], ['asc'])
      return this.showMore ? _tasks.slice(0, this.filterNum) : _tasks
    },
    showMore () {
      return this.tasks.length > (this.filterNum + 1)
    },
    maxHeight () {
      let allDayHeight = `${(this.showMore ? (this.filterNum + 1) : this.tasks.length) * 23}px`
      return allDayHeight
    }
  },
  watch: {
    curDate (after, before) {
      this.filterNum = DEFAULT_SHOW_NUMBER
    }
  },
  methods: {
    showAll () {
      if (this.tasks.length > 200) {
        this.$postMessage.stateGo('app.my.task')
      } else {
        this.filterNum = this.filterNum === DEFAULT_SHOW_NUMBER ? this.tasks.length : DEFAULT_SHOW_NUMBER
      }
    }
  }
}
</script>
<style lang="stylus">
.calendar-adday-task
  margin-right 18px
  display flex
  justify-content flex-start
  align-items stretch
  background-color #f3f3f3
  &-left
    width 58px
    padding 6px 0 8px 18px
    display flex
    flex-direction column
    flex-wrap nowrap
    align-items flex-start
    color #999
    justify-content space-between
  &-title
    font-size .75rem
  &-toggle
    display flex
    width 20px
    height 20px
    background-color #f8f8f9
    border-radius 50%
    justify-content center
    align-items center
    cursor pointer
    .ibass-arrow-down
      color #a9a9a9
      height 14px
    .ibass-arrow-up
      color #a9a9a9
      height 16px
  &-items
    width 100%
    z-index 3
    padding 5px 0 0 2px
    overflow hidden
    &.transition
      transition height .3s ease-out
  &-item
    background-color #FCF4DB
    width 98%
    margin 0 5px 5px 0
    padding-left 5px
    font-size .75rem
    cursor pointer
    outline none
    &.done
      background-color #f8f8f9
      border unset
      .ibass-done
        color #999
        margin-right 5px
        vertical-align -1px
      .calendar-adweek-task-label
        color #999
        text-decoration line-through
  &-trigger
    height 17px
    outline none
    &.triggered
      background-color #FFD9B9
  &-label
    margin-left 8px
    overflow hidden
    text-overflow ellipsis
    white-space nowrap
    cursor pointer
  &-more
    color #666
    font-size .75rem
    cursor pointer
    .ibass
      height 12px
      margin-left 2px
      color #cdc9c5
      vertical-align -2px
</style>
